import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';

// Observable class extensions
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';

// Observable operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';

@Injectable()
export class WebApiObservableService {
	headers: Headers;
    options: RequestOptions;
    basicUrl='http://test.eatasiafood.com/api/v1';
  constructor(private http: Http) { 
  	 this.headers = new Headers({ 'Content-Type': 'application/json; charset=UTF-8'});
     this.options = new RequestOptions({ headers: this.headers });
  }

    getService(url: string): Observable<any> {
         this.options = new RequestOptions({ headers: this.headers });
        return this.http
            .get(this.basicUrl + url, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getSlidersService(url: string): Observable<any> {
        this.options = new RequestOptions({ headers: this.headers });
        return this.http
            .get(this.basicUrl + url, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getServiceWithDynamicQueryTerm(url: string, key: string, val: string): Observable<any> {
        console.log(url,key,val)
        return this.http
            .get(this.basicUrl + url + "/?" + key + "=" + val, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getServiceForSearch(url: string, key: string, val: string): Observable<any> {
        return this.http
            .get(this.basicUrl + url + "/search?" + key + "=" + val, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    search(url: string, key: string, val: string): Observable<any> {
        return this.http
            .get(this.basicUrl + url + "/search?" + key + "=" + val)
            .map(this.extractData)
            .catch(this.handleError);
    }
    searchorders(url: string, key: string, val: string,token: string): Observable<any> {
        return this.http
            .get(this.basicUrl + url + "/search?" + key + "=" + val+ "&access-token=" + token)
            .map(this.extractData)
            .catch(this.handleError);
    }
    searchaddress(url: string, key: string, val: string, token: string): Observable<any> {
        return this.http
            .get(this.basicUrl + url + "/search?" + key + "=" + val + "&expand=colony&access-token=" + token)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getServiceWithFixedQueryString(url: string, param: any): Observable<any> {
        this.options = new RequestOptions({ headers: this.headers, search: 'query=' + param });
        return this.http
            .get(this.basicUrl + url, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getServiceWithComplexObjectAsQueryString(url: string, param: any): Observable<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (var key in param) {
            if (param.hasOwnProperty(key)) {
                let val = param[key];
                params.set(key, val);
            }
        }
        this.options = new RequestOptions({ headers: this.headers, search: params });
        return this.http
            .get(this.basicUrl + url+'/search', this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    getServiceWithOrderDetail(url: string, param: any): Observable<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (var key in param) {
            if (param.hasOwnProperty(key)) {
                let val = param[key];
                params.set(key, val);
            }
        }
        this.options = new RequestOptions({ headers: this.headers, search: params });
        return this.http
            .get(this.basicUrl + url+'/get-order-food-detail', this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    createService(url: string, param: any): Observable<any> {

        let body = JSON.stringify(param);
        this.headers = new Headers({ 'Content-Type': 'application/json; charset=UTF-8'});
        this.options = new RequestOptions({ headers: this.headers });
        return this.http
            .post(this.basicUrl + url, body, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    createAddress(url: string, param: any,token: string): Observable<any> {

        let body = JSON.stringify(param);
        this.headers = new Headers({ 'Content-Type': 'application/json; charset=UTF-8'});
        this.options = new RequestOptions({ headers: this.headers });
        return this.http
            .post(this.basicUrl + url + "?access-token=" + token, body, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    createOrder(url: string, param: any): Observable<any> {
        let body = JSON.stringify(param);
        return this.http
            .post(this.basicUrl + url, body, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    updateUser(url: string, param: any,token: string): Observable<any> {
        let body = JSON.stringify(param);
        this.options = new RequestOptions({ headers: this.headers });
        return this.http
            .put(this.basicUrl + url + "?access-token=" + token, body, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getCapchaService(url: string): Observable<any> {
        this.options = new RequestOptions({ headers: this.headers });
        return this.http
            .get(this.basicUrl + url, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    updateService(url: string, param: any): Observable<any> {
        let body = JSON.stringify(param);
        this.options = new RequestOptions({ headers: this.headers });
        return this.http
            .put(this.basicUrl + url, body, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    updateAddress(url: string, param: any,token: string): Observable<any> {
        let body = JSON.stringify(param);
         this.options = new RequestOptions({ headers: this.headers });
        return this.http
            .put(this.basicUrl + url+"?access-token=" + token, body, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    patchService(url: string, param: any): Observable<any> {
        let body = JSON.stringify(param);
        return this.http
            .patch(this.basicUrl+ url, body, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    deleteService(url: string, param: any): Observable<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (var key in param) {
            if (param.hasOwnProperty(key)) {
                let val = param[key];
                params.set(key, val);
            }
        }
        this.options = new RequestOptions({ headers: this.headers, search: params });
        return this.http
            .delete(this.basicUrl + url, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    deleteServiceWithId(url: string, val: string, token: string): Observable<any> {
     this.options = new RequestOptions({ headers: this.headers });
        return this.http
            .delete(this.basicUrl + url + "/" + val+"?access-token="+ token, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }

    private handleError(error: any) {
        let errMsg = (error.message) ? error.message :
            error.status ? error.json() : error;
        console.error(errMsg);
        return Observable.throw(errMsg);
    }

   

}



// WEBPACK FOOTER //
// D:/deliverproject/eatasiafood/src/app/web-api-observable/web-api-observable.service.ts